<template>
      <box title="Historial del paciente" icon="fa fa-history" :contraction='true'>
            <!-- Toggle de vista -->
            <div class="modo-vista mt-2 p-2 d-flex justify-content-end align-items-center">
                <div @click="viewMode = 'table'" :class="['icon-container mr-2 p-2', { active: viewMode === 'table' }]">
                    <i class="fa-solid fa-table-list p-0 m-0"></i>
                </div>
                <div @click="viewMode = 'timeline'" :class="['icon-container p-2', { active: viewMode === 'timeline' }]">
                    <i class="fa-solid fa-timeline p-0 m-0"></i>
                </div>
            </div>

            <!-- Vista Timeline -->
            <section v-if="viewMode === 'timeline'" class="timeline-container mt-4">
                <div v-if="!filteredHistory || filteredHistory.length === 0" class="text-center text-muted">
                    <p>No hay historial disponible</p>
                </div>
                <div v-else class="row">
                    <div class="col-12">
                        <div class="simple-timeline">
                            <div v-for="item in filteredHistory" 
                                :key="item.data && item.data.cita ? item.data.cita : item.id" 
                                class="timeline-item">
                                <div :class="['timeline-dot', {'current-item': isCurrentItem(item)}]">
                                    <i class="fas fa-circle"></i>
                                </div>
                                <div class="timeline-content">
                                    <div class="timeline-header">
                                        <span class="timeline-title">
                                            {{item.data && item.data.producto && item.data.producto.nombre}}
                                        </span>
                                        <span class="timeline-date mr-2 badge badge-primary">
                                            {{item.fechaReserva}}
                                        </span>
                                    </div>
                                    <div class="timeline-body">
                                        <p v-if="item.data && item.data.metadata && item.data.metadata.preclinica_motivo && item.data.metadata.preclinica_motivo.motivo_principal_consulta" 
                                           class="text-muted mb-2">
                                            {{item.data.metadata.preclinica_motivo.motivo_principal_consulta}}
                                        </p>
                                        <div class="timeline-actions">
                                            <button class="btn btn-sm btn-outline-primary" 
                                                    title="Ir a consulta"
                                                    @click.stop="goToPage(`/medic/ficha/${item.data.reserva.id}`)">
                                                <i class="fa-solid fa-file-medical mr-1"></i>
                                                Ver consulta
                                            </button>
                                            <button class="btn btn-sm btn-outline-info" 
                                                    title="Ver resumen"
                                                    @click.stop="handlerResumeModal(item)">
                                                <i class="fa-regular fa-eye mr-1"></i>
                                                Ver resumen
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Vista Tabla -->
            <section v-if="viewMode === 'table'" class="mt-4">
                <div v-if="!filteredHistory || filteredHistory.length === 0" class="text-center text-muted">
                    <p>No hay historial disponible</p>
                </div>
                <div v-else class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Especialidad</th>
                                <th>Motivo de consulta</th>
                                <th width="100">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in filteredHistory" 
                                :key="item.data && item.data.cita ? item.data.cita : item.id">
                                <td>{{item.fechaReserva}}</td>
                                <td>{{item.data && item.data.producto && item.data.producto.nombre}}</td>
                                <td>{{item.data && item.data.metadata && item.data.metadata.preclinica_motivo && item.data.metadata.preclinica_motivo.motivo_principal_consulta}}</td>
                                <td>
                                    <div class="d-flex justify-content-around">
                                        <i class="fa-solid fa-file-medical text-primary mr-2 p-2 action-icon" 
                                           title="Ir a consulta"
                                           @click="goToPage(`/medic/ficha/${item.data.reserva.id}`)"></i>
                                        <i class="fa-regular fa-eye text-info mr-2 p-2 action-icon" 
                                           title="Ver resumen"
                                           @click="handlerResumeModal(item)"></i>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </box>

        <!-- Modal de Resumen -->
        <div v-if="showResumeModal" class="order-search">
            <div class="modal-dialog modal-80">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <h3>Resumen de consulta</h3>
                            <button class="btn btn-danger" @click="handlerResumeModal">
                                Cerrar <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <!-- Información del Paciente -->
                        <box title="Información del paciente" icon="fa fa-user">
                            <div class="row p-3">
                                <div class="col-md-3">
                                    <h6 class="text-primary">Nombre:</h6>
                                    <p>{{ `${dataResumeModal.data && dataResumeModal.data.metadata_cliente && dataResumeModal.data.metadata_cliente.nombres} ${dataResumeModal.data && dataResumeModal.data.metadata_cliente && dataResumeModal.data.metadata_cliente.apellidos}` }}</p>
                                </div>
                                <div class="col-md-3">
                                    <h6 class="text-primary">Género:</h6>
                                    <p>{{ dataResumeModal.data && dataResumeModal.data.metadata_cliente && dataResumeModal.data.metadata_cliente.genero }}</p>
                                </div>
                                <div class="col-md-3">
                                    <h6 class="text-primary">Edad:</h6>
                                    <p>{{ dataResumeModal.data && dataResumeModal.data.metadata_cliente && dataResumeModal.data.metadata_cliente.edad }}</p>
                                </div>
                                <div class="col-md-3">
                                    <h6 class="text-primary">Fecha de atención:</h6>
                                    <p>{{ dataResumeModal.fechaReserva }}</p>
                                </div>
                            </div>
                        </box>

                        <!-- Motivo de Consulta -->
                        <box title="Motivo de consulta" icon="fa fa-question-circle" :contraction='true'>
                            <div v-if="dataResumeModal.data && dataResumeModal.data.metadata && dataResumeModal.data.metadata.preclinica_motivo && dataResumeModal.data.metadata.preclinica_motivo.motivo_principal_consulta" class="p-3">
                                <p>{{dataResumeModal.data.metadata.preclinica_motivo.motivo_principal_consulta}}</p>
                                <div v-if="dataResumeModal.data && dataResumeModal.data.metadata && dataResumeModal.data.metadata.preclinica_motivo && dataResumeModal.data.metadata.preclinica_motivo.historial_de_la_enfermedad_actual_hpi" class="mt-3">
                                    <h6 class="text-primary">Historial de la enfermedad actual (HPI):</h6>
                                    <p>{{dataResumeModal.data.metadata.preclinica_motivo.historial_de_la_enfermedad_actual_hpi}}</p>
                                </div>
                            </div>
                            <div v-else class="p-3">
                                <div class="text-center text-danger">No se especificó un motivo de consulta</div>
                            </div>
                        </box>


                        <!-- Antecedentes -->
                        <box title="Antecedentes" icon="fa fa-history" :contraction='true'>
                            <div v-if="dataResumeModal.data && dataResumeModal.data.metadata_cliente" class="p-3">
                                <!-- Antecedentes Generales -->
                                <div v-if="dataResumeModal.data.metadata_cliente.antecedentes && dataResumeModal.data.metadata_cliente.antecedentes.antecedentes_generales" class="mb-4">
                                    <h6 class="text-primary">Antecedentes Generales:</h6>
                                    <div class="antecedentes-generales">
                                        {{ dataResumeModal.data.metadata_cliente.antecedentes.antecedentes_generales }}
                                    </div>
                                </div>

                                <!-- Antecedentes Familiares -->
                                <div v-if="filteredAntecedentesFamiliares.length" class="mb-4">
                                    <h6 class="text-primary">Antecedentes Familiares:</h6>
                                    <div class="row">
                                        <div v-for="antecedente in filteredAntecedentesFamiliares" 
                                             :key="antecedente.key"
                                             class="col-12 col-md-6 mb-2">
                                            <div class="d-flex flex-column antecedente-container">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-check text-success mr-2"></i>
                                                    <span class="text-capitalize text-wrap-anywhere">{{ antecedente.label }}</span>
                                                </div>
                                                <div v-if="antecedente.detail" 
                                                     class="text-muted ml-4 small antecedente-detail">
                                                    {{ antecedente.detail }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Antecedentes Traumáticos -->
                                <div v-if="filteredAntecedentesTraumaticos.length" class="mb-4">
                                    <h6 class="text-primary">Antecedentes Traumáticos:</h6>
                                    <div class="row">
                                        <div v-for="antecedente in filteredAntecedentesTraumaticos" 
                                             :key="antecedente.key"
                                             class="col-12 col-md-6 mb-2">
                                            <div class="d-flex flex-column antecedente-container">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-check text-success mr-2"></i>
                                                    <span class="text-capitalize text-wrap-anywhere">{{ antecedente.label }}</span>
                                                </div>
                                                <div v-if="antecedente.detail" 
                                                     class="text-muted ml-4 small antecedente-detail">
                                                    {{ antecedente.detail }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Antecedentes Hábitos -->
                                <div v-if="filteredAntecedentesHabitos.length" class="mb-4">
                                    <h6 class="text-primary">Hábitos:</h6>
                                    <div class="row">
                                        <div v-for="antecedente in filteredAntecedentesHabitos" 
                                             :key="antecedente.key"
                                             class="col-12 col-md-6 mb-2">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-check text-success mr-2"></i>
                                                    <span class="text-capitalize">{{ antecedente.label }}</span>
                                                </div>
                                                <div v-if="antecedente.detail" 
                                                     class="text-muted ml-4 small">
                                                    {{ antecedente.detail }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Antecedentes Alergias -->
                                <div v-if="filteredAntecedentesAlergia.length" class="mb-4">
                                    <h6 class="text-primary">Alergias:</h6>
                                    <div class="row">
                                        <div v-for="antecedente in filteredAntecedentesAlergia" 
                                             :key="antecedente.key"
                                             class="col-12 col-md-6 mb-2">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-check text-success mr-2"></i>
                                                    <span class="text-capitalize">{{ antecedente.label }}</span>
                                                </div>
                                                <div v-if="antecedente.detail" 
                                                     class="text-muted ml-4 small">
                                                    {{ antecedente.detail }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Antecedentes Medicamentos -->
                                <div v-if="filteredAntecedentesMedicamentos.length" class="mb-4">
                                    <h6 class="text-primary">Medicamentos:</h6>
                                    <div class="row">
                                        <div v-for="medicamento in filteredAntecedentesMedicamentos" 
                                             :key="medicamento.key"
                                             class="col-12 mb-2">
                                            <div class="d-flex flex-column border-bottom pb-2 antecedente-container">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-pills text-success mr-2"></i>
                                                    <strong class="text-wrap-anywhere">{{ medicamento.label }}</strong>
                                                </div>
                                                <div class="text-muted ml-4 small antecedente-detail">
                                                    <div><strong>Inicio:</strong> {{ medicamento.fechaInicio }}</div>
                                                    <div><strong>Fuente:</strong> {{ medicamento.fuente }}</div>
                                                    <div v-if="medicamento.observaciones" class="text-wrap-anywhere">
                                                        <strong>Observaciones:</strong> {{ medicamento.observaciones }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Antecedentes Quirúrgicos -->
                                <div v-if="filteredAntecedentesQuirurgicos.length" class="mb-4">
                                    <h6 class="text-primary">Antecedentes Quirúrgicos:</h6>
                                    <div class="row">
                                        <div v-for="antecedente in filteredAntecedentesQuirurgicos" 
                                             :key="antecedente.key"
                                             class="col-12 col-md-6 mb-2">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-check text-success mr-2"></i>
                                                    <span class="text-capitalize">{{ antecedente.label }}</span>
                                                </div>
                                                <div v-if="antecedente.detail" 
                                                     class="text-muted ml-4 small">
                                                    {{ antecedente.detail }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Antecedentes Médicos -->
                                <div v-if="filteredAntecedentesMedicos.length" class="mb-4">
                                    <h6 class="text-primary">Antecedentes Médicos:</h6>
                                    <div class="row">
                                        <div v-for="antecedente in filteredAntecedentesMedicos" 
                                             :key="antecedente.key"
                                             class="col-12 col-md-6 mb-2">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-check text-success mr-2"></i>
                                                    <span class="text-capitalize">{{ antecedente.label }}</span>
                                                </div>
                                                <div v-if="antecedente.detail" 
                                                     class="text-muted ml-4 small">
                                                    {{ antecedente.detail }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="p-3">
                                <div class="text-center text-danger">No hay antecedentes registrados</div>
                            </div>
                        </box>

                        <!-- Signos Vitales -->
                        <box title="Signos vitales" icon="fa fa-heartbeat" :contraction='true'>
                            <div v-if="dataResumeModal.data && dataResumeModal.data.metadata && dataResumeModal.data.metadata.preclinica_signos_v" class="table-responsive p-3">
                                <table class="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>Fecha y hora</th>
                                            <th>PA</th>
                                            <th>FC</th>
                                            <th>FR</th>
                                            <th>SatO₂</th>
                                            <th>Temp</th>
                                            <th>Peso</th>
                                            <th>Talla</th>
                                            <th>IMC</th>
                                            <th>Glicemia</th>
                                            <th>Estado</th>
                                            <th>Dolor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in dataResumeModal.data.metadata.preclinica_signos_v" :key="item.id">
                                            <td>{{ item && item.detail ? item.detail.fechaHora : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.presionArterial : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.frecuenciaCardiaca : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.frecuenciaRespiratoria : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.saturacionDeOxigeno : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.temperatura : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.peso : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.talla : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.IMC : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.glicemia : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.estadoDeConciencia : '' }}</td>
                                            <td>{{ item && item.detail ? item.detail.dolor + '/10' : '' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="p-3">
                                <div class="text-center text-danger">No tiene signos vitales registrados</div>
                            </div>
                        </box>

                        <!-- Diagnóstico -->
                        <box title="Diagnóstico" icon="fas fa-laptop-medical" :contraction='true'>
                            <div v-if="dataResumeModal.data && dataResumeModal.data.metadata && (dataResumeModal.data.metadata.impresion_clinica_cie10 && dataResumeModal.data.metadata.impresion_clinica_cie10.length || dataResumeModal.data.metadata.impresion_clinica && dataResumeModal.data.metadata.impresion_clinica.length)" class="p-3">
                                <template v-if="dataResumeModal.data.metadata.impresion_clinica_cie10 && dataResumeModal.data.metadata.impresion_clinica_cie10.length">
                                    <div v-for="item in dataResumeModal.data.metadata.impresion_clinica_cie10" 
                                         :key="item" 
                                         class="mb-2">
                                        {{ item }}
                                    </div>
                                </template>
                                <template v-if="dataResumeModal.data.metadata.impresion_clinica && dataResumeModal.data.metadata.impresion_clinica.length">
                                    <div v-for="item in dataResumeModal.data.metadata.impresion_clinica" 
                                         :key="item" 
                                         class="mb-2" 
                                         v-html="nl2br(item)">
                                    </div>
                                </template>
                            </div>
                            <div v-else class="p-3">
                                <div class="text-center text-danger">No tiene diagnóstico registrado</div>
                            </div>
                        </box>

                        <!-- Tratamiento -->
                        <box title="Tratamiento" icon="fa fa-comment-medical" :contraction='true'>
                            <div v-if="dataResumeModal.data && dataResumeModal.data.metadata && dataResumeModal.data.metadata.tratamiento && dataResumeModal.data.metadata.tratamiento.observaciones" class="p-3">
                                <div class="mb-2" v-html="nl2br(dataResumeModal.data.metadata.tratamiento.observaciones)"></div>
                                <div class="text-right mt-3">
                                    <button class="btn btn-primary" @click="printTratamiento">
                                        <i class="fas fa-print"></i> Imprimir tratamiento
                                    </button>
                                </div>
                            </div>
                            <div v-else class="p-3">
                                <div class="text-center text-danger">No tiene tratamiento registrado</div>
                            </div>
                        </box>

                        <!-- Receta -->
                        <box title="Receta médica" icon="fas fa-receipt" :contraction='true'>
                            <div v-if="dataResumeModal.data && dataResumeModal.data.metadata && dataResumeModal.data.metadata.tratamiento_receta" class="p-3">
                                <div class="table-responsive">
                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Medicamento</th>
                                                <th>Administración</th>
                                                <th>Dosis</th>
                                                <th>Frecuencia</th>
                                                <th>Duración</th>
                                                <th>Observaciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="receta in Object.values(dataResumeModal.data.metadata.tratamiento_receta)" :key="receta.id">
                                                <td>{{ receta.detail.medicamento }}</td>
                                                <td>{{ receta.detail.administracion }}</td>
                                                <td>{{ receta.detail.dosis }}</td>
                                                <td>Cada {{ receta.detail.cada }}</td>
                                                <td>Durante {{ receta.detail.durante }}</td>
                                                <td>{{ receta.detail.observaciones }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="text-right mt-3">
                                    <button class="btn btn-primary" @click="printReceta">
                                        <i class="fas fa-print"></i> Imprimir receta
                                    </button>
                                </div>
                            </div>
                            <div v-else class="p-3">
                                <div class="text-center text-danger">No tiene receta registrada</div>
                            </div>
                        </box>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import API from "src/core/Api";
import {mapGetters} from "vuex";
import dayjs from "dayjs";
import Box from "src/modules/medico/views/fichas/Box.vue";

export default {
    name: 'HistorialPaciente',
    components: {
        Box
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            viewMode: 'timeline',
            showResumeModal: false,
            dataResumeModal: {
                data: {
                    metadata_cliente: {},
                    metadata: {
                        preclinica_motivo: {},
                        preclinica_signos_v: [],
                        impresion_clinica_cie10: [],
                        impresion_clinica: [],
                        tratamiento: {},
                        tratamiento_receta: []
                    },
                    producto: {},
                    reserva: {}
                },
                fechaReserva: ''
            },
            history: [],
            metadata_cliente: {}
        };
    },
    computed: {
        ...mapGetters({
            GetMedicoFichaActive: 'GetMedicoFichaActive',
            GetHistoryFiltred: 'GetHistoryFiltred'
        }),
        sortedHistory() {
            if (!this.history || !Array.isArray(this.history)) return [];
            return this.history.slice().sort((a, b) => {
                const dateA = new Date(a.fechaReserva);
                const dateB = new Date(b.fechaReserva);
                return dateB - dateA; // Orden descendente (más reciente primero)
            });
        },
        filteredHistory() {
            return this.sortedHistory.filter(item => 
                item.data && typeof item.data.status === 'undefined'
            );
        },
        filteredAntecedentesFamiliares() {
            if (!this.dataResumeModal.data || !this.dataResumeModal.data.metadata_cliente || 
                !this.dataResumeModal.data.metadata_cliente.antecedentes_familiares) return [];
            return Object.entries(this.dataResumeModal.data.metadata_cliente.antecedentes_familiares)
                .filter(([key, value]) => value === '1' && !key.includes('_detail'))
                .map(([key]) => ({
                    key,
                    label: key.replace(/_/g, ' '),
                    detail: this.dataResumeModal.data.metadata_cliente.antecedentes_familiares[key + '_detail']
                }));
        },
        filteredAntecedentesHabitos() {
            if (!this.dataResumeModal.data || !this.dataResumeModal.data.metadata_cliente || 
                !this.dataResumeModal.data.metadata_cliente.antecedentes_habitos) return [];
            return Object.entries(this.dataResumeModal.data.metadata_cliente.antecedentes_habitos)
                .filter(([key, value]) => value === '1' && !key.includes('_detail'))
                .map(([key]) => ({
                    key,
                    label: key.replace(/_/g, ' '),
                    detail: this.dataResumeModal.data.metadata_cliente.antecedentes_habitos[key + '_detail']
                }));
        },
        filteredAntecedentesAlergia() {
            if (!this.dataResumeModal.data || !this.dataResumeModal.data.metadata_cliente || 
                !this.dataResumeModal.data.metadata_cliente.antecedentes_alergia) return [];
            
            // Las alergias tienen una estructura diferente, son objetos numerados
            return Object.values(this.dataResumeModal.data.metadata_cliente.antecedentes_alergia)
                .map(alergia => ({
                    key: alergia.id,
                    label: alergia.detail.alergiaA,
                    detail: `Reacción: ${alergia.detail.reaccion}, Severidad: ${alergia.detail.severidad}`
                }));
        },
        filteredAntecedentesQuirurgicos() {
            if (!this.dataResumeModal.data || !this.dataResumeModal.data.metadata_cliente || 
                !this.dataResumeModal.data.metadata_cliente.antecedentes_quirurgicos) return [];
            return Object.entries(this.dataResumeModal.data.metadata_cliente.antecedentes_quirurgicos)
                .filter(([key, value]) => value === '1' && !key.includes('_detail'))
                .map(([key]) => ({
                    key,
                    label: key.replace(/_/g, ' '),
                    detail: this.dataResumeModal.data.metadata_cliente.antecedentes_quirurgicos[key + '_detail']
                }));
        },
        filteredAntecedentesMedicos() {
            if (!this.dataResumeModal.data || !this.dataResumeModal.data.metadata_cliente || 
                !this.dataResumeModal.data.metadata_cliente.antecedentes_medicos) return [];
            return Object.entries(this.dataResumeModal.data.metadata_cliente.antecedentes_medicos)
                .filter(([key, value]) => value === '1' && !key.includes('_detail'))
                .map(([key]) => ({
                    key,
                    label: key.replace(/_/g, ' '),
                    detail: this.dataResumeModal.data.metadata_cliente.antecedentes_medicos[key + '_detail']
                }));
        },
        filteredAntecedentesTraumaticos() {
            if (!this.dataResumeModal.data || !this.dataResumeModal.data.metadata_cliente || 
                !this.dataResumeModal.data.metadata_cliente.antecedentes_traumaticos) return [];
            return Object.entries(this.dataResumeModal.data.metadata_cliente.antecedentes_traumaticos)
                .filter(([key, value]) => value === '1' && !key.includes('_detail'))
                .map(([key]) => ({
                    key,
                    label: key.replace(/_/g, ' '),
                    detail: this.dataResumeModal.data.metadata_cliente.antecedentes_traumaticos[key + '_detail']
                }));
        },
        filteredAntecedentesMedicamentos() {
            if (!this.dataResumeModal.data || !this.dataResumeModal.data.metadata_cliente || 
                !this.dataResumeModal.data.metadata_cliente.antecedentes_medicamentos) return [];
            
            // Los medicamentos tienen una estructura similar a las alergias
            return Object.values(this.dataResumeModal.data.metadata_cliente.antecedentes_medicamentos)
                .map(medicamento => ({
                    key: medicamento.id,
                    label: medicamento.detail.nombreYFormulacion,
                    fechaInicio: medicamento.detail.fechaInicio,
                    fuente: medicamento.detail.fuente,
                    observaciones: medicamento.detail.observaciones
                }));
        }
    },
    watch: {
        show: {
            immediate: true,
            handler(value) {
                if (value && this.GetMedicoFichaActive && this.GetMedicoFichaActive.cliente && this.GetMedicoFichaActive.cliente.id) {
                    this.loadItems();
                }
            }
        },
        GetHistoryFiltred: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.history = value;
                }
            }
        }
    },
    methods: {
        dayjs,
        close() {
            this.$emit('close');
        },
        goToPage(url) {
            window.location.href = url;
        },
        handlerResumeModal(item = null) {
            if (item) {
                const antecedentes_generales = this.metadata_cliente.antecedentes && this.metadata_cliente.antecedentes.antecedentes_generales || '';
                
                this.dataResumeModal = {
                    data: {
                        metadata_cliente: {
                            ...this.metadata_cliente,
                            antecedentes_generales,
                            antecedentes_familiares: this.metadata_cliente.antecedentes_familiares || {},
                            antecedentes_traumaticos: this.metadata_cliente.antecedentes_traumaticos || {},
                            antecedentes_habitos: this.metadata_cliente.antecedentes_habitos || {},
                            antecedentes_alergia: this.metadata_cliente.antecedentes_alergia || {},
                            antecedentes_medicamentos: this.metadata_cliente.antecedentes_medicamentos || {},
                            antecedentes_quirurgicos: this.metadata_cliente.antecedentes_quirurgicos || {},
                            antecedentes_medicos: this.metadata_cliente.antecedentes_medicos || {}
                        },
                        metadata: {
                            preclinica_motivo: (item.data && item.data.metadata && item.data.metadata.preclinica_motivo) || {},
                            preclinica_signos_v: (item.data && item.data.metadata && item.data.metadata.preclinica_signos_v) || [],
                            impresion_clinica_cie10: [],
                            impresion_clinica: [],
                            tratamiento: (item.data && item.data.metadata && item.data.metadata.tratamiento) || {},
                            tratamiento_receta: (item.data && item.data.metadata && item.data.metadata.tratamiento_receta) || []
                        },
                        producto: (item.data && item.data.producto) || {},
                        reserva: (item.data && item.data.reserva) || {}
                    },
                    fechaReserva: item.fechaReserva || ''
                };

                // Handle impresion_clinica_cie10 data
                if (item.data && item.data.metadata && item.data.metadata.impresion_clinica_cie10) {
                    if (Array.isArray(item.data.metadata.impresion_clinica_cie10)) {
                        this.dataResumeModal.data.metadata.impresion_clinica_cie10 = item.data.metadata.impresion_clinica_cie10;
                    } else if (typeof item.data.metadata.impresion_clinica_cie10 === 'object') {
                        this.dataResumeModal.data.metadata.impresion_clinica_cie10 = Object.values(item.data.metadata.impresion_clinica_cie10);
                    }
                }

                // Handle impresion_clinica data
                if (item.data && item.data.metadata && item.data.metadata.impresion_clinica) {
                    if (typeof item.data.metadata.impresion_clinica === 'object' && item.data.metadata.impresion_clinica.observaciones) {
                        this.dataResumeModal.data.metadata.impresion_clinica = [item.data.metadata.impresion_clinica.observaciones];
                    } else if (Array.isArray(item.data.metadata.impresion_clinica)) {
                        this.dataResumeModal.data.metadata.impresion_clinica = item.data.metadata.impresion_clinica;
                    }
                }
            }
            this.showResumeModal = !this.showResumeModal;
        },
        nl2br(str) {
            if (str) {
                return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
            }
            return str;
        },
        loadItems() {
            if (!this.GetMedicoFichaActive || !this.GetMedicoFichaActive.cliente || !this.GetMedicoFichaActive.cliente.id) return;
            
            API.send('POST', 'medico/getHistory', {
                'clienteId': this.GetMedicoFichaActive.cliente.id
            }, 
            (response) => {
                if (response.data && response.data.historico && Array.isArray(response.data.historico)) {
                    this.history = response.data.historico;
                    this.metadata_cliente = response.data.metadata_cliente || {};
                }
            },
            (response) => {
                API.showErrorAlert(response.msg || 'Error al cargar el historial');
            });
        },
        printReceta() {
            // Implementar lógica de impresión de receta
            console.log('Imprimir receta');
        },
        printTratamiento() {
            // Implementar lógica de impresión de tratamiento
            console.log('Imprimir tratamiento');
        },
        isCurrentItem(item) {
            // Verificar si este ítem corresponde a la ficha actual
            if (!item || !item.data || !item.data.reserva || !item.data.reserva.id) {
                return false;
            }
            
            // Obtener el ID de la ficha actual
            const currentReservaId = this.GetMedicoFichaActive && 
                                    this.GetMedicoFichaActive.reserva && 
                                    this.GetMedicoFichaActive.reserva.id;
            
            // Comparar con el ítem actual
            return item.data.reserva.id === currentReservaId;
        }
    }
};
</script>

<style scoped>
/* Toggle de vistas */
.modo-vista {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 1rem;
}

.icon-container {
    width: 37px;
    height: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.icon-container:hover, .icon-container.active {
    background-color: #f8f9fa;
    border-color: #0056b3;
}

.icon-container i {
    font-size: 1.2rem;
    color: #6c757d;
}

.icon-container.active i {
    color: #0056b3;
}

/* Timeline */
.simple-timeline {
    position: relative;
    padding: 0;
    margin-bottom: 1rem;
}

.simple-timeline:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 2px;
    background: #e9ecef;
    left: 12px;
    top: 0;
}

.timeline-item {
    position: relative;
    margin-bottom: 1rem;
    padding-left: 35px;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #f1f1f1;
}

.timeline-item:last-child {
    border-bottom: none;
}

.timeline-dot {
    position: absolute;
    left: 6px;
    top: 4px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #e0e6ff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.timeline-item:first-child .timeline-dot {
    background-color: #e0e6ff;
}

/* Estilo para el ítem actual */
.timeline-dot.current-item {
    background-color: #467bfe;
}

.timeline-dot i {
    font-size: 8px;
    color: #fff;
}

.timeline-content {
    padding: 0;
}

.timeline-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 5px;
}

.timeline-title {
    font-weight: 500;
    color: #333;
    word-break: break-word;
    flex: 1;
    padding-right: 10px;
}

.timeline-date {
    font-size: 0.8rem;
    white-space: nowrap;
}

.timeline-body {
    margin-top: 5px;
}

.timeline-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.timeline-actions .btn {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}

/* Scroll styles */
.simple-timeline::-webkit-scrollbar {
    width: 4px;
}

.simple-timeline::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.simple-timeline::-webkit-scrollbar-thumb {
    background: #ced4da;
}

.simple-timeline::-webkit-scrollbar-thumb:hover {
    background: #adb5bd;
}

/* Modal */
.order-search {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-dialog {
    max-width: 90%;
    margin: 1.75rem auto;
}

.modal-80 {
    max-width: 80%;
    width: 80%;
}

.modal-content {
    max-height: 90vh;
    overflow-y: auto;
}

/* Contenido */
.treatment-text {
    white-space: pre-wrap;
    font-family: inherit;
    font-size: 1rem;
    background: transparent;
    border: none;
    padding: 0;
}

/* Responsive */
@media (max-width: 768px) {
    .fichaMedicaHistorial {
        padding: 10px;
    }

    .modal-dialog {
        max-width: 95%;
        margin: 1rem auto;
    }

    .timeline-item {
        padding: 0.75rem;
        padding-left: 45px;
    }

    .timeline-dot {
        left: 10px;
    }

    .simple-timeline:before {
        left: 16px;
    }

    .timeline-header {
        flex-direction: row;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .timeline-title {
        flex: 1;
        min-width: 60%;
    }

    .timeline-date {
        margin-top: 0;
        margin-bottom: 0;
        text-align: right;
    }

    .timeline-actions {
        flex-direction: column;
        width: 100%;
    }

    .timeline-actions .btn {
        width: 100%;
        justify-content: center;
        margin-bottom: 5px;
    }
}

/* Estilos para los botones de acción en la tabla */
.action-icon {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.action-icon:hover {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background-color: rgba(0, 0, 0, 0.05);
}

.action-icon.fa-file-medical:hover {
    color: #0056b3 !important;
}

.action-icon.fa-eye:hover {
    color: #17a2b8 !important;
}

/* Estilos para el manejo de textos largos */
.text-wrap-anywhere {
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
}

.antecedente-detail {
    white-space: normal;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
    padding-right: 15px;
}

.antecedente-container {
    width: 100%;
}

/* Ajustar el contenedor de antecedentes generales */
.antecedentes-generales {
    white-space: normal;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 15px;
}
</style>